interface SeverityRange {
  min: number;
  max: number;
  label: string;
  color:
    | "error"
    | "default"
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning";
}

const mapScoreToSeverity: Record<string, SeverityRange[]> = {
  "GAD-7": [
    {
      min: 0,
      max: 4,
      label: "Minimal",
      color: "default",
    },
    {
      min: 5,
      max: 9,
      label: "Mild",
      color: "primary",
    },
    {
      min: 10,
      max: 14,
      label: "Moderate",
      color: "warning",
    },
    {
      min: 15,
      max: 21,
      label: "Severe",
      color: "error",
    },
  ],
  "PHQ-9": [
    {
      min: 0,
      max: 4,
      label: "Minimal",
      color: "default",
    },
    {
      min: 5,
      max: 9,
      label: "Mild",
      color: "primary",
    },
    {
      min: 10,
      max: 14,
      label: "Moderate",
      color: "warning",
    },
    {
      min: 15,
      max: 19,
      label: "Moderately Severe",
      color: "error",
    },
    {
      min: 20,
      max: 27,
      label: "Severe",
      color: "error",
    },
  ],
};

export const getSeverity = (type: string, score: number) => {
  const ranges = mapScoreToSeverity[type];

  const match = ranges.find((r) => score >= r.min && score <= r.max);

  if (match == null) return null;

  return { label: match.label, color: match.color };
};
